import mapValues from 'lodash/mapValues';
import pickBy from 'lodash/pickBy';
import trim from 'lodash/trim';

export const filterEmptyValues = (data: object) => pickBy(mapValues(data, trim), Boolean);
